import { create } from "zustand";

// Live view of whether push actually works on this device. Deliberately not
// persisted: it describes the current browser session, and a stale "healthy"
// value is exactly the failure mode this store exists to expose.
const usePushStatusStore = create((set) => ({
  permission: "default",
  hasToken: false,
  error: "",
  setPushStatus: ({ permission, hasToken, error } = {}) =>
    set({
      permission: permission || "default",
      hasToken: Boolean(hasToken),
      error: error || "",
    }),
}));

const HEALTH = {
  ok: {
    ok: true,
    reason: "ok",
    actionable: false,
    message: "Notifications are on for this device.",
  },
  no_token: {
    ok: false,
    reason: "no_token",
    actionable: true,
    // Permission looks fine but this device has no live registration — the case
    // that silently stops delivery after the token is rotated or pruned.
    message: "Notifications are allowed, but this device isn't registered. Tap to reconnect.",
  },
  blocked: {
    ok: false,
    reason: "blocked",
    actionable: false,
    message: "Notifications are blocked. Turn them on in your device settings, then reopen INSSA.",
  },
  not_enabled: {
    ok: false,
    reason: "not_enabled",
    actionable: true,
    message: "Turn on notifications to hear about capsules, messages and rewards.",
  },
  unsupported: {
    ok: false,
    reason: "unsupported",
    actionable: false,
    message: "This browser can't receive notifications. Install INSSA to your home screen first.",
  },
};

export const selectPushHealth = (state) => {
  if (state?.permission === "unsupported") return HEALTH.unsupported;
  if (state?.permission === "denied") return HEALTH.blocked;
  if (state?.permission !== "granted") return HEALTH.not_enabled;
  return state?.hasToken ? HEALTH.ok : HEALTH.no_token;
};

export const selectSetPushStatus = (state) => state.setPushStatus;

export default usePushStatusStore;
